import { render, staticRenderFns } from "./OrderMoreOptions.vue?vue&type=template&id=0400f3ef&"
import script from "./OrderMoreOptions.vue?vue&type=script&lang=js&"
export * from "./OrderMoreOptions.vue?vue&type=script&lang=js&"
import style0 from "./OrderMoreOptions.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports